import state from "../state";
import globals from "../constants/env";

export function showAlert(message, cb) {
	if (message instanceof Error) {
		console.error("receieved an error, expecting an Object", message);
	}
	showInfo("Info", message, cb);
}

export function dismissAlert() {
	state.select(["appState", "alerts"]).set([]);
}

export function showInfo(title, message, cb) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			id: new Date().getTime() + Math.random(),
			type: "info",
			title,
			message,
			callback: cb
		});
	} else {
		alert(message);
		if (cb) {
			cb();
		}
	}
}

export function showError(title, message, cb) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			id: new Date().getTime() + Math.random(),
			type: "danger",
			title,
			message,
			callback: cb
		});
	} else {
		alert(message);
		if (cb) {
			cb();
		}
	}
}

export function showWarning(title, message, cb) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			id: new Date().getTime() + Math.random(),
			type: "warning",
			title,
			message,
			callback: cb
		});
	} else {
		alert(message);
		if (cb) {
			cb();
		}
	}
}

export function showSuccess(title, message, cb) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			id: new Date().getTime() + Math.random(),
			type: "success",
			title,
			message,
			callback: cb
		});
	} else {
		alert(message);
		if (cb) {
			cb();
		}
	}
}

export function showConfirm(message, title, onConfirm) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			message,
			title,
			onConfirm
		});
	} else {
		if (window.confirm(message)) {
			onConfirm();
		}
	}
}

export function showYesNo(message, title, onYesNo) {
	if (globals.config.useFancyAlerts) {
		state.select(["appState", "alerts"]).push({
			message,
			title,
			onYesNo
		});
	} else {
		if (window.confirm(message)) {
			onYesNo();
		}
	}
}

export function showError2(title, err) {
	if (err === null) {
		showError(title, "Unknown error.");
	} else if (err.code === "NetworkingError") {
		showError(title, "Network error. Please check connectivity and try again.");
	} else {
		showError(title, `${err.message}\n\nDetail: ${err.stack}`);
	}
}
